import { Children, useState, useEffect } from 'react'
import GroupsIcon from '@mui/icons-material/Groups'
import {
  List,
  Datagrid,
  Create,
  TextField,
  NumberField,
  useRefresh,
  useUpdate,
  Button,
  FunctionField,
  FilterForm,
  FilterButton,
  SearchInput,
  ArrayField,
  useDataProvider,
  SimpleForm,
  SelectInput,
  DateInput,
  required,
  SaveButton,
  Toolbar,
  TextInput,
  useRecordContext,
  Edit,
  BooleanInput,
  DatagridBody,
  DatagridRow,
  RecordContextProvider,
  Form,
} from 'react-admin'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { makeStyles } from '@material-ui/core/styles'
import {
  Link,
  Dialog,
  Typography,
  Button as ButtonM,
  IconButton,
  Box,
  Tooltip,
  Grid,
  DialogTitle,
  DialogContent,
  Chip,
  TableRow,
  TableCell,
  Backdrop,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  TextField as TextFieldM,
} from '@material-ui/core'
import CheckIcon from '@mui/icons-material/Check'
import DeleteIcon from '@mui/icons-material/Delete'
import { ExtraPagination, openUrl } from './utils'
import TextFieldWithTooltip from './components/text_field_with_tooltip'
import {
  CreateCoprosGeneralNews,
  EditCoprosGeneralNews,
  ListCoprosGeneralNews,
} from './copros/copros_general_news'
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from 'react-router'
import Api from './Apis/api.service'
import CSMemberIllustration from './assets/images/undraw_powerful_re_frhr.svg'
import SplitButton from './common/Buttons/SplitButton'
import config from './config'
import ApiRequest from './Apis/request'
import WarningIcon from '@mui/icons-material/Warning'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  customDatagridHeaderCell: {
    padding: '8px',
  },
  customDatagridRowCell: {
    padding: '8px',
  },
  rowStyle: {
    cursor: 'pointer',
    '&:hover': {
      background: '#fff',
    },
  },
})

const FormToolbar = (props) => (
  <Toolbar>
    <SaveButton onClick={props.handleClose} />
    <ButtonM onClick={props.handleClose} color="primary">
      Fermer
    </ButtonM>
  </Toolbar>
)

//record = copro
const CoproTextButton = () => {
  const record = useRecordContext()
  const [tickets, setTickets] = useState()
  const [isOpen, setIsOpen] = useState(false)

  const toggleIsOpen = (event) => {
    event.stopPropagation()
    setTickets()
    setIsOpen((previous) => !previous)
  }

  const handleSubmit = async ({ from, to }) => {
    const errorCodeToSentence = {
      MISSING_COPRO_ID: "L'identifiant de la copropriété est manquant.",
      DATES_ARE_MANDATORY: 'Veuillez spécifier une plage de dates valide.',
      DATES_MUST_BE_CONSISTENT:
        'Veuillez spécifier une plage de dates cohérente.',
    }

    if (!record.id) {
      alert(errorCodeToSentence.MISSING_COPRO_ID)
      return
    }

    if (!from || !to) {
      alert(errorCodeToSentence.DATES_ARE_MANDATORY)
      return
    }

    if (from > to) {
      alert(errorCodeToSentence.DATES_MUST_BE_CONSISTENT)
      return
    }

    const closedTicketStatuses = new Set([
      'Etat daté clôturé',
      'Visite effectuée',
      'Intervention terminée',
      'Décision prise',
      'Action terminée',
      'Dossier clôturé',
      'Facture uploadée',
      'Décisions prises',
      'Intervention évaluée',
      'Demande terminée',
    ])

    const apiRequest = new ApiRequest()

    try {
      const {
        data: { tickets },
      } = await apiRequest.get(
        `/copros_text/${record.id}?from=${from}&to=${to}`
      )

      if (!tickets.length) {
        setTickets(null)
        return
      }

      const sortedTickets = tickets.reduce(
        (_sortedTickets, ticket) => {
          if (closedTicketStatuses.has(ticket.status)) {
            return {
              ..._sortedTickets,
              closed: [..._sortedTickets.closed, ticket],
            }
          }

          return {
            ..._sortedTickets,
            opened: [..._sortedTickets.opened, ticket],
          }
        },
        { opened: [], closed: [] }
      )

      const formatDate = (date) =>
        new Date(date).toLocaleString('fr-FR', {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        })

      setTickets({
        ...sortedTickets,
        from: formatDate(from),
        to: formatDate(to),
      })
    } catch (error) {
      const {
        response: { data },
      } = error

      if (errorCodeToSentence[data.code]) {
        alert(errorCodeToSentence[data.code])
        return
      }

      alert(
        'Une erreur inhabituelle est survenue, veuillez contacter le support technique.'
      )
    }
  }

  return (
    <>
      <Backdrop
        open={isOpen}
        onClick={toggleIsOpen}
        style={{ background: '#ffffff03' }}
      >
        <Dialog open={isOpen}>
          <Box
            sx={{ padding: '1.5rem' }}
            onClick={(event) => event.stopPropagation()}
          >
            <Form onSubmit={handleSubmit}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '1.5rem',
                }}
              >
                <Typography component="p">
                  Veuillez sélectionner une plage de dates
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '1rem',
                  }}
                >
                  <DateInput
                    label="Du"
                    source="from"
                    onChange={() => setTickets()}
                  />
                  <DateInput
                    label="au"
                    source="to"
                    onChange={() => setTickets()}
                  />
                </Box>
                <Button
                  label="Générer le résumé"
                  type="submit"
                  size="medium"
                  sx={{ marginTop: '-1.5rem' }}
                />
              </Box>
            </Form>
            {tickets === null && (
              <Typography
                component="p"
                style={{
                  marginTop: '1.5rem',
                  padding: '1rem',
                  textAlign: 'center',
                  border: '1px solid',
                }}
              >
                Aucun ticket trouvé pour la période spécifiée.
              </Typography>
            )}

            {tickets && (
              <Box
                sx={{
                  border: '1px solid',
                  padding: '1rem',
                  marginTop: '1.5rem',
                }}
              >
                <Typography component="p">Madame, Monsieur,</Typography>
                <Typography component="p" style={{ marginTop: '1rem' }}>
                  C&apos;est avec plaisir que je vous joins la liste des actions
                  réalisées ou en cours sur votre copropriété sur la période du{' '}
                  {tickets.from} au {tickets.to}.
                </Typography>
                <Typography
                  component="p"
                  style={{ margin: '1rem 0', textDecoration: 'underline' }}
                >
                  Actions terminées :
                </Typography>
                <Box component="ul" sx={{ padding: '0 1rem' }}>
                  {!tickets.closed.length ? (
                    <Typography component="li">
                      Aucune action terminée sur la période spécifiée.
                    </Typography>
                  ) : (
                    tickets.closed.map(
                      ({
                        id,
                        libelle,
                        status,
                        latest_status_updated_at,
                        created,
                      }) => (
                        <Typography key={id} component="li">
                          {libelle}{' '}
                          <em>
                            ({status} le {latest_status_updated_at || created})
                          </em>
                        </Typography>
                      )
                    )
                  )}
                </Box>
                <Typography
                  component="p"
                  style={{ margin: '1rem 0', textDecoration: 'underline' }}
                >
                  Actions en cours :
                </Typography>
                <Box component="ul" sx={{ padding: '0 1rem' }}>
                  {!tickets.opened.length ? (
                    <Typography component="li">
                      Aucune action en cours sur la période spécifiée.
                    </Typography>
                  ) : (
                    tickets.opened.map(
                      ({
                        id,
                        libelle,
                        status,
                        latest_status_updated_at,
                        created,
                      }) => (
                        <Typography key={id} component="li">
                          {libelle}{' '}
                          <em>
                            ({status} le {latest_status_updated_at || created})
                          </em>
                        </Typography>
                      )
                    )
                  )}
                </Box>
                <Typography component="p" style={{ margin: '1rem 0' }}>
                  Nous restons à votre disposition si vous avez des questions,
                </Typography>
                <Typography component="p">L&apos;équipe Manda.</Typography>
              </Box>
            )}
          </Box>
        </Dialog>
      </Backdrop>
      <Button label="Résumé" onClick={toggleIsOpen} />
    </>
  )
}
const CoproDetails = () => {
  const record = useRecordContext()

  const handleClick = () => {
    window.open(
      window.location.origin + '/copros/' + record.id + '/show',
      '_blank'
    )
  }

  return (
    <div>
      <Button label="Détails" onClick={handleClick} />
    </div>
  )
}

const PacLink = () => {
  const record = useRecordContext()
  if (!record['copros_monday_internal_id']) {
    return null
  }
  return record.is_archived === true ? (
    'N/A'
  ) : (
    <Link
      href={
        window.location.origin +
        '/ext_coprosummary/' +
        record['copros_monday_internal_id']
      }
      target="_blank"
    >
      PAC
    </Link>
  )
}

//record = copro
const RoleField = (props) => {
  const record = useRecordContext()
  const { src } = props

  if (record.is_archived === true) return null

  if (record[src].length === 0) {
    return null
  } else {
    return record[src].map((source) => (
      <Box key={source.id} display="flex" alignItems="center">
        <Tooltip title={source.fullname.trim()}>
          <Typography variant="body2">
            {source.fullname.trim().substring(0, 5) + '...'}
          </Typography>
        </Tooltip>
      </Box>
    ))
  }
}

//record = contact
const RevokeMandatButton = ({ refresh, cs_president }) => {
  const record = useRecordContext()
  const dataProvider = useDataProvider()

  if (!window.context['user_type']?.includes('Admin')) {
    return null
  }

  const handleClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    dataProvider
      .delete('role_instances', {
        id: cs_president
          ? cs_president.role_instance_id
          : record.role_instance_id,
      })
      .then(({ data }) => {
        refresh()
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <IconButton onClick={handleClick} size="small">
      <DeleteIcon fontSize="small" />
    </IconButton>
  )
}

//record = copro
const MandatField = ({ label, src, role_id, refresh }) => {
  const record = useRecordContext()
  const [showDialog, setShowDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [contactId, setContactId] = useState(null)
  const [dateDebut, setDateDebut] = useState(null)
  const [errors, setErrors] = useState({})
  const [showDialogCsMember, setShowDialogCsMember] = useState(false)

  const toggleDialogCsMember = (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    setShowDialogCsMember(!showDialogCsMember)
  }
  const toggleDialog = (e) => {
    e?.stopPropagation()
    e?.preventDefault()
    setShowDialog(!showDialog)
  }

  if (record.is_archived === true) return null

  const contacts = record.contacts
  const cs_members = contacts.filter((c) => c.role_id === 2)
  const cs_presidents = contacts.filter((c) => c.role_id === 1)
  const options = contacts.map((c) => {
    return { id: c.copromatic_id, name: c.fullname }
  })
  const onSuccess = () => {
    refresh()
  }
  const validate = (payload) => {
    let valid = true
    if (!payload.contact_id) {
      valid = false
      setErrors(() => {
        return { ...errors, contact_id: true }
      })
    }
    if (!payload.debut) {
      valid = false
      setErrors(() => {
        return { ...errors, debut: true }
      })
    }
    return valid
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    setLoading(true)
    let payload = {
      copro_id: record.id,
      role_id: role_id,
      contact_id: contactId,
      debut: dateDebut,
    }
    const isValid = validate(payload)
    if (!isValid) {
      setLoading(false)
      return
    }
    const res = await Api.users.roleIntances(payload)
    if (res.status == 200) {
      onSuccess()
      toggleDialog()
    }
    setLoading(false)
  }
  const enriched_record = {
    cs_presidents: cs_presidents,
    cs_members: cs_members,
    ...record,
  }

  if (src === 'cs_presidents') {
    if (enriched_record[src].length > 0) {
      return (
        <Box display="flex" alignItems="center">
          <Tooltip title={enriched_record.cs_presidents[0].fullname.trim()}>
            <Typography variant="body2">
              {enriched_record.cs_presidents[0].fullname.trim()}
            </Typography>
          </Tooltip>
        </Box>
      )
    } else {
      return null
    }
  } else {
    //if cs_members, we can add cs_members even if there are some already
    return (
      <>
        {enriched_record.cs_members.length ? (
          <>
            <Button
              label={`${enriched_record.cs_members.length} membre(s)`}
              onClick={toggleDialogCsMember}
            />
          </>
        ) : null}

        <Backdrop
          open={showDialogCsMember}
          onClick={toggleDialogCsMember}
          style={{ background: '#ffffff03' }}
        >
          <div onClick={(event) => event.stopPropagation()}>
            <Dialog open={showDialogCsMember} fullWidth={true} maxWidth={'md'}>
              <DialogTitle>Membre du Conseil Syndical</DialogTitle>
              <Box
                sx={{
                  margin: '15px 0 15px 0',
                  textAlign: 'center',
                  fontSize: '13px',
                  color: 'rgb(245, 160, 75)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <WarningIcon sx={{ margin: '0 10px 0 0' }}></WarningIcon>
                <Box>
                  L'édition des membres du CS est disponible uniquement via
                  Copromatic.
                  <br /> Vos modifications seront prises en compte lors de la
                  mise à jour nocturne de Copromatic.
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                }}
              >
                <Box sx={{ width: '100%', flex: 1 }}>
                  <ArrayField record={enriched_record} source={src}>
                    <Datagrid bulkActionButtons={false}>
                      <TextField source="fullname" label={label} />
                      <TextField source="mail" label="Email" />
                    </Datagrid>
                  </ArrayField>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src={CSMemberIllustration}
                    width={'100%'}
                    height="300px"
                    marginTop="10px"
                  />
                </Box>
              </Box>
              <DialogActions>
                <ButtonM onClick={toggleDialogCsMember}>Fermer</ButtonM>
              </DialogActions>
            </Dialog>
          </div>
        </Backdrop>
      </>
    )
  }
}

const CoproFilter = () => {
  const dataProvider = useDataProvider()
  const [coproManagerChoices, setCoproManagerChoices] = useState([])
  const [accountants, setAccountants] = useState([])

  useEffect(() => {
    dataProvider
      .getList('copros_monday/copro_managers', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'copro_manager', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setCoproManagerChoices(data)
      })
      .catch(() => {
        setCoproManagerChoices([])
      })

    dataProvider
      .getList('copros_monday/accountants', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'accountant', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setAccountants(data)
      })
      .catch(() => {
        setAccountants([])
      })
  }, [dataProvider])

  return [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput source="is_archived" label="Archivé" alwaysOn />,
    <SelectInput
      source="resp"
      label="Copro Manager"
      choices={coproManagerChoices}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
    <SelectInput
      source="statut59"
      label="Comptable"
      choices={accountants}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
  ]
}

const NewsButton = () => {
  const record = useRecordContext()
  return (
    <>
      <Chip label={record?.lastnewsactive} color="info" />
    </>
  )
}

const CSMembers = () => {
  const record = useRecordContext()
  const contacts = record.contacts
  const cs_members = contacts.filter((c) => c.role_id === 2)
  const cs_presidents = contacts.filter((c) => c.role_id === 1)
  let color = ''
  if (cs_members.length == 0 && cs_presidents.length == 0) {
    color = '#E86B6B'
  } else if (cs_members.length && cs_presidents.length == 0) {
    color = '#FFA500'
  } else if (cs_presidents.length) {
    color = '#66BB6A'
  }
  return (
    <>
      <GroupsIcon style={{ color: color }} />
    </>
  )
}
const CustomColumn = () => {
  const record = useRecordContext()
  const handleClick = (event) => {
    event.stopPropagation()
    // Handle the click event for the custom column here
    // without triggering the rowClick event for the entire row
  }

  return (
    <div onClick={handleClick}>
      <FunctionField
        label="PAC"
        render={(record) => <PacLink record={record} />}
      />
    </div>
  )
}
export const CoproList = (props) => {
  const classes = useStyles()
  const [gestionnaires, setGestionnaires] = useState([])
  const [comptables, setComptables] = useState([])
  const dataProvider = useDataProvider()
  const user_type = window.context['user_type']
  const refresh = useRefresh()
  const [showCreateGeneralNews, setShowCreateGeneralNews] = useState(false)
  const [idGeneralNews, setIdGeneralNews] = useState(false)
  const [openNewsDialog, setOpenNewsDialog] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams()
  function transformedParams(object, keys = ['displayedFilters', 'filter']) {
    const result = {}
    for (const [key, value] of Object.entries(object)) {
      if (keys.includes(key)) {
        result[key] = JSON.stringify({ ...value })
      } else {
        result[key] = value
      }
    }
    return result
  }
  useEffect(() => {
    let listParams = JSON.parse(
      localStorage.getItem('RaStore.copros.listParams')
        ? localStorage.getItem('RaStore.copros.listParams')
        : '{}'
    )
    listParams = transformedParams(listParams)
    setSearchParams({ ...listParams })
  }, [])
  useEffect(() => {
    dataProvider
      .getList('users', { pagination: {}, sort: {}, filter: {} })
      .then(({ data }) => {
        var gestionnaires = data
          .filter((u) => u.user_type.includes('Gestionnaire'))
          .map((i) => {
            return { id: i.id, name: i.firstname + ' ' + i.lastname }
          })
        var comptables = data
          .filter((u) => u.user_type.includes('Comptable'))
          .map((i) => {
            return { id: i.id, name: i.firstname + ' ' + i.lastname }
          })
        setGestionnaires(gestionnaires)
        setComptables(comptables)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  const ListFilters = (props) => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <FilterForm filters={CoproFilter(props)} />
        </Grid>
        <Grid
          item
          style={{
            position: 'relative',
            flexGrow: 0,
            maxWidth: '14.666667%',
            flexBasis: '14.666667%',
          }}
        >
          <FilterButton
            style={{ position: 'absolute', bottom: '5px', right: 0 }}
            filters={CoproFilter(props)}
          />
        </Grid>
      </Grid>
    )
  }
  const [listKey, setListKey] = useState(0)

  const params = new URLSearchParams(location.search)
  const filterParam = params.get('filter')

  // force the remount of the list when a filter changes
  useEffect(() => {
    setListKey((prevKey) => prevKey + 1)
  }, [filterParam])

  return (
    <>
      <List
        key={listKey}
        exporter={false}
        pagination={<ExtraPagination />}
        perPage={50}
        actions={<ListFilters {...props} />}
        sort={{ field: 'copro_manager', order: 'ASC' }}
      >
        <MyDatagrid
          size={'small'}
          bulkActionButtons={false}
          classes={{
            headerCell: classes.customDatagridHeaderCell,
            rowCell: classes.customDatagridRowCell,
          }}
        >
          <TextField source="id" label="Id copromatic" />
          <TextFieldWithTooltip source="libelle" maxLength={4} />
          <TextField source="code" label="Code" />
          <TextFieldWithTooltip source="adresse" maxLength={4} />
          <TextFieldWithTooltip source="ville" maxLength={4} />
          <TextField source="nb_tickets" label="Nb tickets" />
          <CustomColumn />
          <CSMembers label="CS member" />
          <MandatField
            {...props}
            label="Président CS"
            src="cs_presidents"
            role_id={1}
            refresh={refresh}
          />
          <MandatField
            {...props}
            label="Membre du cs"
            src="cs_members"
            role_id={1}
            refresh={refresh}
          />
          {user_type && user_type.includes('Admin') && (
            <TextField source="copro_manager" label="Copro Manager" />
          )}
          {user_type && user_type.includes('Admin') && (
            <TextField source="accountant" label="Comptable" />
            //TODO discuss if we can clean the users in hello app so we can rely on it, and
            // use our tables users and user_copros to get the accountants and copro managers
            // instead of relying on monday

            // <RoleField
            //   {...props}
            //   src="comptables"
            //   label="Comptable"
            //   options={comptables}
            //   refresh={refresh}
            // />
          )}
          <CoproTextButton />
          <CoproDetails />
          <TextFieldWithTooltip source="fiche_news" maxLength={4} />
          <NewsButton />
          <ButtonAction />
        </MyDatagrid>
      </List>
    </>
  )
}
const ButtonAction = () => {
  const record = useRecordContext()
  return (
    <SplitButton
      getActions={async () => {
        return await generateActions(record)
      }}
    />
  )
}
const generateActions = async (record) => {
  return [
    {
      option: 'Voir copropriétaires',
      onClick: () => {
        const url = `${config.REACT_APP_HELLO_APP_INTRANET}/copros/${record.id}/coproprietaires`
        openUrl(url)
      },
      disabled: false,
    },
    {
      option: 'Voir documents',
      onClick: () => {},
      disabled: true,
    },
  ]
}
const MyDatagridRow = ({ record, id, children, ...props }) => {
  const navigate = useNavigate()
  const classes = useStyles()
  return (
    <RecordContextProvider value={record}>
      <TableRow
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          navigate(`/copros/${id}/show`)
        }}
      >
        {/* data columns based on children */}
        {Children.map(children, (field) => (
          <TableCell key={`${id}-${field?.props?.source}`}>{field}</TableCell>
        ))}
      </TableRow>
    </RecordContextProvider>
  )
}

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow />} />
)
const MyDatagrid = (props) => <Datagrid {...props} body={<MyDatagridBody />} />
